import * as React from "react";
const SvgTagUnion = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 8 22", fill: "current_color", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0 0H8L2.28571 11L8 22H0V11V0Z", fill: "inherit" }));
export default SvgTagUnion;
